import { Lightning } from '@lightningjs/sdk'
import { isLowEndDevice } from '../../utils/info'
import LottieAnimation from './LottieAnimation'
import { SpriteAnimation } from './SpriteAnimation'

export class Loader extends Lightning.Component {
  private readonly _isLowEndDevice = isLowEndDevice()

  static _template() {
    return {}
  }

  _init() {
    this.patch({
      children: [
        {
          x: (w) => w / 2,
          y: (h) => h / 2,
          mount: 0.5,
          type: this._isLowEndDevice ? SpriteAnimation : LottieAnimation,
          width: this.w,
          height: this.h,
        },
      ],
    })
  }

  set width(v: number) {
    // Match animation width
    this.w = v
  }

  set height(v: number) {
    // Match animation height
    this.h = v
  }
}
